module.exports = __webpack_public_path__ + "static/media/email-market.548fcc28.svg";